import script from "./CompanyDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyDetails.vue?vue&type=style&index=0&id=83e79e7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83e79e7e"]])

export default __exports__